import VueRouter from 'vue-router';

let routes = [
  {
    path: '/features',
    component: () => import('./pages/Features.vue'),
  },
  {
    path: '/privacy',
    component: () => import('./pages/Privacy.vue'),
  },
  {
    path: '*',
    component: () => import('./pages/Home.vue'),
  },
];


export default new VueRouter({
  routes,
  mode: 'history',

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition)
      return savedPosition;

    if (to.hash)
      return { selector: to.hash }

    return { x: 0, y: 0 }
  }
});
